import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('BORROWING', {
  FETCH_SUMMARIES_REQUEST: null,
  FETCH_SUMMARIES_SUCCESS: null,
  FETCH_SUMMARIES_FAILURE: null
});



// WEBPACK FOOTER //
// ./app/constants/BorrowingConstants.js